import { useEffect } from "react";
import { closeLoginModal } from "../../core/Global";
import LoginPage from "../../modules/auth/views/LoginPage";
import Modal from "../base/Modal";
import { useNavigate } from "react-router-dom";
import { isNativeApp } from "../../NativeAppBrdige";




export default function ModalLogin() {


    const navigate = useNavigate()

    useEffect(() => {
        if (isNativeApp()) {
            document.location.href = "/auth/login"
        }
    }, [])

    return (
        <Modal id="modal-relogin"
            title="Login"
            onClose={() => closeLoginModal()}
            open visible noHeader noFooter noForm staticBackdrop>
            <div className='py-10'>
                <LoginPage redirectUrl={window.location.pathname} />
            </div>
        </Modal>
    )
}